// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"322b5ce7","796":"f53dc5da","963":"dda937eb"}[chunkId] + ".chunk.js";
};